import Tracking from '../../analytics/Tracking';

export default function initNavbarTracking() {
    let loginSubscribeLoginBox = document.getElementById("login_subscribe_login_box");
    let userInfoSubscribeLoginBox = document.getElementById("user-info_subscribe_login_box");
    let subscribeBarButton = document.getElementById("subscribe-bar__button");
    let subscribeBarButtonMobile = document.getElementById("subscribe-bar__button__mobile");
    
    let contentSubscribeButton = document.getElementById("content-subscribe-box-button");

    [loginSubscribeLoginBox, subscribeBarButton, subscribeBarButtonMobile, userInfoSubscribeLoginBox, contentSubscribeButton].forEach(b => {
        b && b.addEventListener('click', function (event) {
            let eventCategory = b.getAttribute("data-event-category") || "Ad"
            let actionName = b.getAttribute("data-action-name") || "subscriptionAdClick"
            let data = window.hardPaywallTrackingData || {editionId: "de"};
            
            Tracking.track(`action.${actionName}`, data);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'UniversalEvent',
                'eventCategory': `Wort+ | ${eventCategory}`,
                'eventAction': 'Click',
                'eventLabel': 'Promo'
            });
        })
    })
}



// WEBPACK FOOTER //
// ./js/navbar/desktop/NavbarTracking.js